<div class="container">

    <div class="content" fxLayout="row" fxLayoutAlign="center center">

        <span class="value">SALE</span>

    </div>

</div>